"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../../constants");
var SessionManager = /** @class */ (function () {
    function SessionManager(storage, browser) {
        this.storage = storage;
        this.session = storage.get('currentSession');
        this.browser = browser;
    }
    SessionManager.prototype.initSession = function () {
        if (this.session === null)
            this.resetSession();
        if (this.sessionHasExpired())
            this.resetSession();
        this.saveCurrentPath(this.browser.currentPathname);
    };
    SessionManager.prototype.resetSession = function () {
        this.session = {
            browseAbandonmentSent: false,
            date: new Date(),
            pageViewCounter: 0,
            pagesVisited: [],
            renderedCampaigns: [],
            kryptonite: false // This flag is used to render the HE pixel only once
        };
        this.saveSession();
    };
    Object.defineProperty(SessionManager.prototype, "currentSession", {
        get: function () {
            return this.session;
        },
        enumerable: false,
        configurable: true
    });
    SessionManager.prototype.addCampaignRendering = function (campaignID) {
        var campaignHasNotBeenRendered = this.session.renderedCampaigns.find(function (cid) { return cid === campaignID; }) === undefined;
        if (campaignHasNotBeenRendered) {
            this.session.renderedCampaigns.push(campaignID);
            this.saveSession();
        }
    };
    SessionManager.prototype.markKryptoniteAsRendered = function () {
        this.session.kryptonite = true;
        this.saveSession();
    };
    SessionManager.prototype.saveCurrentPath = function (path) {
        this.session.pageViewCounter++;
        this.session.pagesVisited.push(path);
        this.saveSession();
    };
    SessionManager.prototype.saveContactSubscription = function (subscription) {
        var subscriptionStatusIsValid = ['subscribed', 'unsubscribed'].includes(subscription.status);
        var lastUpdated = new Date(subscription.lastUpdated);
        var lastUpdatedIsValid = !Number.isNaN(lastUpdated.valueOf());
        if (!subscriptionStatusIsValid || !lastUpdatedIsValid)
            return;
        this.session.subscription = {
            status: subscription.status,
            lastUpdated: lastUpdated
        };
        this.saveSession();
    };
    SessionManager.prototype.sessionHasExpired = function () {
        var sessionEnd = new Date();
        sessionEnd.setTime(sessionEnd.getTime() - constants_1.SESSION_DURATION);
        return new Date(this.session.date) < sessionEnd;
    };
    SessionManager.prototype.updateBrowseAbandonmentSent = function (sent) {
        this.session.browseAbandonmentSent = Boolean(sent);
        this.saveSession();
    };
    SessionManager.prototype.saveSession = function () {
        this.storage.set('currentSession', this.session);
    };
    return SessionManager;
}());
exports.default = SessionManager;
//# sourceMappingURL=data:application/json;base64,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